import { ARMOR_TYPES, EquipmentPack, StartEquipmentItem, WEAPON_KEYWORDS } from "@dndModels";

import DataUtilities from "@dndUtilities/data_utilities";

const data_util = DataUtilities.getInstance();

export interface ChoiceSelection {
  selectedOptionId: string;
  typeItemSelections: Record<string, string>; // itemId -> selected base item id
}

// Helper function to render individual option items
export function renderOptionItem(item: StartEquipmentItem, equipmentPacks: EquipmentPack[]): string {
  switch (item.item_type) {
    case "Item": {
      const itemObj = data_util.items.find(o => o._id === item.item);
      if (itemObj) {
        return item.item_count > 1 ? `${item.item_count} ${itemObj.name}s` : itemObj.name;
      }
      return "";
    }
    case "Type": {
      if (item.item === "Weapon" && item.detail !== "") {
        const keyword = WEAPON_KEYWORDS.find(o => o._id === item.detail);
        return keyword ? `A ${keyword.name} Weapon of your choice` : `A ${item.item} of your choice`;
      } else if (item.item === "Armor" && item.detail !== "") {
        const armorType = ARMOR_TYPES.find(o => o._id === item.detail);
        return armorType ? `A ${armorType.name} of your choice` : `A ${item.item} of your choice`;
      }
      return `A ${item.item} of your choice`;
    }
    case "Pack": {
      const pack = equipmentPacks.find(o => o._id === item.item);
      if (pack) {
        const packItems = pack.items.map((packItem, i) => {
          const itemObj = data_util.items.find(o => o._id === packItem.item_id);
          if (itemObj) {
            return packItem.count > 1 ? `${packItem.count} ${itemObj.name}` : itemObj.name;
          }
          return "";
        }).filter(Boolean);
        return `${pack.name}: ${packItems.join(", ")}`;
      }
      return "";
    }
    case "Money":
      return item.item;
    case "Other Item":
      return `${item.item} (Will be added to Other Possessions)`;
    default:
      return "";
  }
}